import React, { useEffect } from 'react'
import { Button, TextHeader } from '@wallyhealth/web-core'
import { useSearchParams } from 'react-router-dom'
import intelService from '../../services/intelService'
import styles from './index.module.css'
import CenteredLayout from './CenteredLayout'
import { useUnsubscribe } from './hooks'

const parseCampaignId = (raw) => {
  const parsed = parseInt(raw, 10)
  return Number.isNaN(parsed) ? undefined : parsed
}

const OptOutPage = () => {
  const [search] = useSearchParams()
  const { isUnsubscribing, unsubscribe } = useUnsubscribe()

  const token = search.get('token')
  const campaignId = parseCampaignId(search.get('campaign'))

  useEffect(() => {
    intelService.recordView({ viewName: 'OptOutPage' })
  }, [])

  if (!token) {
    window.location.href = 'https://www.carebywally.com'
    return null
  }

  const onSubmit = () => {
    unsubscribe({ token, campaignId })
  }

  return (
    <CenteredLayout>
      <TextHeader
        title="Unsubscribe from these emails?"
        subtitle="You'll no longer receive marketing emails from us. You can still receive replies to your conversations."
        titleClassName={styles.centerText}
        subtitleClassName={styles.centerText}
      />
      <Button
        className={styles.button}
        label="Unsubscribe"
        onClick={onSubmit}
        isLoading={isUnsubscribing}
      />
    </CenteredLayout>
  )
}

export default OptOutPage
